import gql from 'graphql-tag';

import { FULL_ANSWER_FRAGMENT } from '../fragments/Answer/fullAnswer';

export const GET_ANSWERS_SUBSCRIPTION = gql`
  subscription GetAnswersSubscription($questionId: String!) {
    answer(questionId: $questionId) {
      ...fullAnswer
    }
  }
  ${FULL_ANSWER_FRAGMENT}
`;
